var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4999 4.08337C19.1508 4.08337 14.802 8.43212 14.802 13.7813C14.802 19.0284 18.9058 23.275 24.2549 23.4588C24.4183 23.4384 24.5816 23.4384 24.7041 23.4588C24.7449 23.4588 24.7653 23.4588 24.8062 23.4588C24.8266 23.4588 24.8266 23.4588 24.847 23.4588C30.0737 23.275 34.1774 19.0284 34.1978 13.7813C34.1978 8.43212 29.8491 4.08337 24.4999 4.08337Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8717 28.8896C29.1755 25.0921 19.8859 25.0921 14.1488 28.8896C11.5559 30.625 10.1267 32.973 10.1267 35.4842C10.1267 37.9955 11.5559 40.323 14.1284 42.038C16.9867 43.9571 20.7434 44.9167 24.5 44.9167C28.2567 44.9167 32.0134 43.9571 34.8717 42.038C37.4442 40.3025 38.8734 37.975 38.8734 35.4434C38.853 32.9321 37.4442 30.6046 34.8717 28.8896Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAvatar);
export default __webpack_public_path__ + "static/media/image-avatar.7a80d71d2369269be6be815442f10ec9.svg";
export { ForwardRef as ReactComponent };